type MenuEmptyStateProps = {
  text: string;
};

const MenuEmptyState = (props: MenuEmptyStateProps) => (
  <span
    class="block size-full w-66 py-4 pl-3 text-medium-regular text-secondary"
    role="option"
    aria-selected={false}
    aria-disabled
  >
    {props.text}
  </span>
);

export default MenuEmptyState;
